import main from "./main/es";
import terms from "./terms/es";
import validationMessages from "./validationMessages/es";
import helpText from "./helpText/es";
import button from "./button/es";
import toastMessages from "./toastMessages/es";
import popupMessages from "./popupMessages/es";
import notifications from "./notifications/es";
import placeholders from "./placeholders/es";
import months from "./months/es";
import shortTerms from "./shortTerms/es";
import headlines from "./headlines/es";
import pluralTerms from "./pluralTerms/es";
import table from "./table/es";
import time from "./time/es";
import technicalData from "./technicalData/es";
import editAssetLocation from "./editAssetLocation/es";
import assetBridgeSafetyNotes from "./assetBridgeSafetyNotes/es";

export default {
  main,
  terms,
  validationMessages,
  helpText,
  button,
  toastMessages,
  popupMessages,
  notifications,
  placeholders,
  months,
  shortTerms,
  headlines,
  pluralTerms,
  table,
  time,
  technicalData,
  editAssetLocation,
  assetBridgeSafetyNotes,
};
